let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bmy7P")).then(() => parcelRequire('57ITv'));